import React, { useState, useEffect } from 'react';
import { Clock, MapPin, Mail, Phone, Menu, X, ChevronLeft, ChevronRight, Activity, Heart, Droplets } from 'lucide-react';
export default function WellnessSite() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  // Hero carousel images - REPLACE THESE WITH YOUR OWN IMAGES
  const heroImages = [
    {
      url: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=1200&h=600&fit=crop',
      title: 'Professional Massage Therapy',
      subtitle: 'Expert care in the comfort of your home'
    },
    {
      url: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=1200&h=600&fit=crop',
      title: 'Mobile Massage Service',
      subtitle: 'Bringing relaxation and wellness to you'
    },
    {
      url: 'https://images.unsplash.com/photo-1519824145371-296894a0daa9?w=1200&h=600&fit=crop',
      title: 'Your Wellness Journey',
      subtitle: 'Personalized treatments tailored to your needs'
    }
  ];

  // Gallery images - REPLACE THESE WITH YOUR OWN IMAGES
  const galleryImages = [
    'https://images.unsplash.com/photo-1519824145371-296894a0daa9?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=400&h=300&fit=crop'
  ];

  // Auto-advance carousel
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(timer);
  }, [heroImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroImages.length) % heroImages.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      {/* Header/Navigation */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-3">
            <img src="/hollis-massage-logo.png" alt="Hollis Massage Logo" className="w-20 h-20" />
            
          </div>

            
            {/* Desktop Navigation */}
            <div className="hidden md:flex space-x-8">
              <a href="#home" className="text-gray-700 hover:text-teal-600 transition">Home</a>
              <a href="#services" className="text-gray-700 hover:text-teal-600 transition">Services</a>
              <a href="#about" className="text-gray-700 hover:text-teal-600 transition">About</a>
              <a href="#contact" className="text-gray-700 hover:text-teal-600 transition">Contact</a>
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="md:hidden text-gray-700"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <div className="md:hidden mt-4 pb-4 space-y-3">
              <a href="#home" className="block text-gray-700 hover:text-teal-600">Home</a>
              <a href="#services" className="block text-gray-700 hover:text-teal-600">Services</a>
              <a href="#about" className="block text-gray-700 hover:text-teal-600">About</a>
              <a href="#contact" className="block text-gray-700 hover:text-teal-600">Contact</a>
            </div>
          )}
        </nav>
      </header>

      {/* Hero Carousel Section */}
      <section id="home" className="relative h-screen max-h-screen overflow-hidden">
        {/* Carousel Images */}
        <div className="relative h-full">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img 
                src={image.url} 
                alt={image.title}
                className="w-full h-full object-cover"
              />
              {/* Dark overlay for text readability */}
              <div className="absolute inset-0 bg-black bg-opacity-40"></div>
              
              {/* Text overlay */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center text-white px-4">
                  <h1 className="text-5xl md:text-6xl font-bold mb-4 drop-shadow-lg">
                    {image.title}
                  </h1>
                  <p className="text-xl md:text-2xl text-gray-100 mb-8 drop-shadow-md">
                    {image.subtitle}
                  </p>
                  <button className="bg-brand text-white px-8 py-3 rounded-full font-semibold text-lg hover:bg-teal-700 transition shadow-lg">
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Previous Button */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-50 hover:bg-opacity-75 text-gray-800 p-3 rounded-full transition z-10"
        >
          <ChevronLeft size={24} />
        </button>

        {/* Next Button */}
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-50 hover:bg-opacity-75 text-gray-800 p-3 rounded-full transition z-10"
        >
          <ChevronRight size={24} />
        </button>

        {/* Dots Navigation */}
        <div className="absolute bottom-8 left-0 right-0 flex justify-center space-x-3 z-10">
          {heroImages.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-all ${
                index === currentSlide 
                  ? 'bg-white w-8' 
                  : 'bg-white bg-opacity-50 hover:bg-opacity-75'
              }`}
            />
          ))}
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Welcome to Hollis Massage
          </h2>
          <p className="text-lg text-gray-600 mb-4">
            I'm a fully qualified massage therapist bringing professional treatments directly to your home or workplace in and around Rugby and Warwickshire. 
            I offer personalized massage therapy tailored to your individual needs.
          </p>
          <p className="text-lg text-gray-600">
            Whether you're seeking relief from muscle tension, stress reduction, or simply want to relax and unwind, 
            I provide a mobile service that brings the spa experience to you.
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-gradient-to-b from-white to-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">
            My Services
          </h2>
          <p className="text-center text-gray-600 mb-16 max-w-2xl mx-auto">
            Professional massage therapy services delivered in the comfort of your own home
          </p>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition">
              <div className="w-16 h-16 bg-brand rounded-full flex items-center justify-center mb-4">
                <Activity className="text-white" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Deep Tissue Massage</h3>
              <p className="text-gray-600">
                Focused pressure to release chronic muscle tension and knots. Perfect for athletes and those with persistent pain.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition">
              <div className="w-16 h-16 bg-brand rounded-full flex items-center justify-center mb-4">
                <Heart className="text-white" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Swedish Massage</h3>
              <p className="text-gray-600">
                Classic relaxation massage using flowing strokes to ease tension, improve circulation, and promote overall wellbeing.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition">
               <div className="w-16 h-16 bg-brand rounded-full flex items-center justify-center mb-4">
                <Droplets className="text-white" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Lymphatic Drainage Massage</h3>
              <p className="text-gray-600">
                Gentle, rhythmic massage technique that stimulates the lymphatic system to reduce swelling, boost immunity, and promote detoxification.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">
            Treatment Gallery
          </h2>
          <p className="text-center text-gray-600 mb-16 max-w-2xl mx-auto">
            A glimpse of the professional, relaxing experience I provide
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {galleryImages.map((image, index) => (
              <div 
                key={index} 
                className="relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition group cursor-pointer"
              >
                <img 
                  src={image} 
                  alt={`Treatment ${index + 1}`}
                  className="w-full h-64 object-cover transform group-hover:scale-110 transition duration-500"
                />
                <div className="absolute inset-0 bg-teal-600 bg-opacity-0 group-hover:bg-opacity-20 transition"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section id="contact" className="py-20 bg-gradient-to-b from-white to-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">
            Get In Touch
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {/* Location */}
            <div className="bg-white p-8 rounded-xl shadow-md">
              <div className="flex items-center justify-center w-16 h-16 bg-brand rounded-full mb-6 mx-auto">
                <MapPin className="text-white" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Service Area</h3>
              <p className="text-gray-700 text-center mb-2 font-semibold">Rugby & Surrounding Areas</p>
              <p className="text-gray-600 text-center">Massage in home location or mobile service on request</p>
              <p className="text-gray-600 text-center mt-4 text-sm">Based in central Rugby CV22</p>
            </div>

            {/* Hours */}
            <div className="bg-white p-8 rounded-xl shadow-md">
              <div className="flex items-center justify-center w-16 h-16 bg-brand rounded-full mb-6 mx-auto">
                <Clock className="text-white" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Availability</h3>
              <div className="space-y-2 text-center">
                <p className="text-gray-700"><span className="font-semibold">Monday-Thursday:</span> 5.30pm - 8pm</p>
                <p className="text-gray-700"><span className="font-semibold">Friday:</span> 3pm - 6pm</p>
                <p className="text-gray-700"><span className="font-semibold">Saturday-Sunday:</span> 9am - 5pm</p>
              </div>
              <p className="text-sm text-gray-500 text-center mt-4">
                Flexible scheduling available
              </p>
            </div>

            {/* Contact */}
            <div className="bg-white p-8 rounded-xl shadow-md">
              <div className="flex items-center justify-center w-16 h-16 bg-brand rounded-full mb-6 mx-auto">
                <Mail className="text-white" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Contact Me</h3>
              <div className="space-y-4">
                <a 
                  href="mailto:hollismassage@hotmail.com" 
                  className="flex items-center justify-center text-teal-600 hover:text-teal-700 transition"
                >
                  <Mail size={20} className="mr-2" />
                  hollismassage@hotmail.com
                </a>
                <a 
                  href="tel:+447710 469 484" 
                  className="flex items-center justify-center text-teal-600 hover:text-teal-700 transition"
                >
                  <Phone size={20} className="mr-2" />
                  07710 469 484
                </a>
                <button className="w-full mt-4 bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition shadow-md">
                  Book Your Session
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gray-400">
            Hollis Massage © {new Date().getFullYear()}
          </p>
          <p className="text-sm text-gray-500 mt-2">
            Massage Therapy - Rugbyx
          </p>
        </div>
      </footer>
    </div>
  );
}